import { AxiosInstance } from '@service/axios-instance';

export interface Attachment {
    filename: string;
    url: string;
}

export interface Ticket {
    _id: string;
    tipo_problema: string;
    localizacao: string;
    descricao: string;
    priority: string;
    status: string;
    updated_at?: string;
    sub_status?: string;
    created_at: string;
    created_by: string;
    closed_at?: string;
    closed_by?: string;
    closed_msg?: string;
    close_reason?: string;
    created_by_affiliation?: string;
    time_support?: number;
    time_ops?: number;
    total_duration?: number;
    comments: Comment[];
    attachments: Attachment[];
}

export interface Comment {
    user: string;
    message: string;
    created_at: string;
    user_affiliation?: string;
    attachments: Attachment[];
}

export async function listTickets(db: string) {
    const res = await AxiosInstance.get('/tickets/list', {
        withCredentials: true,
        params: { db }
    });
    return res.data;
}

export async function createTicket(db: string, formData: FormData) {
    const res = await AxiosInstance.post('/tickets/create', formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { db }
    });
    return res.data;
}

export async function closeTicket(db: string, ticketId: string, closeMsg: string, reason: string) {
    const res = await AxiosInstance.patch('/tickets/close', {
        ticket_id: ticketId,
        close_msg: closeMsg,
        close_reason: reason
    }, {
        withCredentials: true,
        params: { db }
    });
    return res.data;
}

export async function addComment(db: string, ticketId: string, formData: FormData) {
    const res = await AxiosInstance.post(`/tickets/${ticketId}/comment`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { db }
    });
    return res.data;
}

export interface TicketMetricsResponse {
    priority_counts: { [key: string]: number };
    avg_close_time: number;
    max_close_time: number;
    total_closed: number;
    volume_by_date: { [key: string]: number };
}

export async function getTicketMetrics(db: string, startDate?: string, endDate?: string) {
    const res = await AxiosInstance.get('/tickets/metrics', {
        withCredentials: true,
        params: {
            db,
            start_date: startDate,
            end_date: endDate
        }
    });
    return res.data as TicketMetricsResponse;
}
